import React from 'react';
import { CheckCircle, AlertTriangle } from 'lucide-react';

/**
 * FeedbackBanner – Einheitliche Erfolgs-/Fehlermeldungen.
 * @param {{ type: 'success' | 'error', text: string } | null} feedback
 * @param {string} [testId]
 */
export function FeedbackBanner({ feedback, testId }) {
  if (!feedback) return null;
  return (
    <div className={`design-feedback ${feedback.type}`} data-testid={testId || 'feedback-banner'}>
      {feedback.type === 'success' ? <CheckCircle size={14} /> : <AlertTriangle size={14} />}
      {feedback.text}
    </div>
  );
}

/**
 * PlaceholderBar – Klickbare Platzhalter für den TipTap Editor.
 * @param {string[]} placeholders
 * @param {(placeholder: string) => void} onInsert
 */
export function PlaceholderBar({ placeholders, onInsert }) {
  if (!placeholders?.length) return null;
  return (
    <div className="card" style={{ marginBottom: '1rem' }}>
      <div className="card-body" style={{ padding: '0.75rem 1rem' }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: 4 }}>Verfügbare Platzhalter</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {placeholders.map(p => (
            <code key={p} style={{ padding: '2px 8px', background: '#f3f4f6', borderRadius: 4, fontSize: 12, color: 'var(--primary)', cursor: 'pointer' }}
              onClick={() => onInsert(p)} title="Klicken zum Einfügen an Cursorposition">
              {'{{' + p + '}}'}
            </code>
          ))}
        </div>
      </div>
    </div>
  );
}
